export default "<router-outlet></router-outlet>\n\n<app-main></app-main>"